<template>
  <el-row>
    <el-col :span="12">
      <app-base-main
          :table-shadow="false"
          border
          table-border-top
          style="height: 516px; padding: 12px;"
          class="base-main__left--picker">
        <template #filter-group>
          <app-filter-group
              :isBr="false"
              :reset="false"
              @query="$gjNoticeQuery">
            <gj-market-select
                v-model="filter.marketId"
                placeholder="全部店铺"
                width="140px"
            ></gj-market-select>
            <gj-input
                v-model="filter.keyword"
                placeholder="父ASIN"
                width="140px"
            ></gj-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              :index="false"
              :loading="loading"
              :data="originTableData"
              :columns="originColumns"
              :adapt-height="false"
              :height="400"
              :pagination-option="{layout: 'total, prev, pager, next, sizes'}"
              :pagination="pagination"
              @page-change="$gjNoticeQuery">
            <template v-slot:header:op>
              <gj-button
                  type="text"
                  @click="addAllItem()">添加全部</gj-button>
            </template>
            <template v-slot:op="{row}">
              <gj-button
                  type="text"
                  :disabled="row.addBtnDisabled"
                  @click="addItem(row)">添加</gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </el-col>
    <el-col :span="12">
      <app-base-main
          :table-shadow="false"
          border
          table-border-top
          size="has-picture"
          style="padding: 12px;"
          class="base-main__right--picker">
        <template #filter-group>
          <div style="margin: 7px 0 6px;">
            <span>已添加 {{form.variationAsinItems.length}} 个商品</span>
          </div>
        </template>
        <template #table>
          <gj-table
              :index="false"
              :data="form.variationAsinItems"
              :columns="pickerColumns"
              :adapt-height="false"
              :height="448">
            <template v-slot:header:op>
              <gj-button
                  type="text"
                  @click="deleteAllItem">移除全部</gj-button>
            </template>
            <template v-slot:op="{row, index}">
              <gj-button
                  type="text"
                  @click="deleteItem(row, index)">移除</gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </el-col>
  </el-row>
</template>

<script>
  import {queryMixin} from "../../../../../../../minxins";
  import {getOperationLogListingPage} from "../../../../../../../api/sale";
  import {OperationLogEnum} from "../../../common/enum";
  import {isMeaningful, meaningfulEq} from "../../../../../../../utils/common";
  import {mapGetters} from "vuex";

  export default {
    name: "app-variation-asin-operation-log-picker",
    mixins: [queryMixin],
    props: {
      form: {
        required: true
      }
    },
    data() {
      return {
        originTableData: [],
        originColumns: [
          {id: 'marketName', header: '店铺', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'variationAsin', header: '父ASIN', field: 'variationAsin', minWidth: '120px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px', fixed: 'right'},
        ],
        pickerColumns: [
          {id: 'marketName', header: '店铺', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'variationAsin', header: '父ASIN', field: 'variationAsin', minWidth: '120px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', width: '80px', fixed: 'right'},
        ],
        filter: {
          marketId: null,
          keyword: null
        },
        option: {
          keyword: [
            {id: 'asin', text: 'ASIN'},
            {id: 'msku', text: 'MSKU'},
            {id: 'variationAsin', text: '父ASIN'},
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            dimension: OperationLogEnum.dimension.VARIATION_ASIN,
            marketId: this.filter.marketId,
            variationAsin: this.filter.keyword,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // params.model[this.filter.keyword.key] = this.filter.keyword.value;
        // 查询
        this.loading = true;
        getOperationLogListingPage(params)
          .then((data) => {
            this.originTableData = (data.records || []);
            this.pagination = this.getPagination(data);
            this.refreshAddBtn();
          })
          .complete(() => this.loading = false);
      },
      addAllItem() {
        this.form.variationAsinItems = this.form.variationAsinItems.concat(this.originTableData.filter(item => !item.addBtnDisabled));
        this.refreshAddBtn();
      },
      addItem(row) {
        if (this.form.variationAsinItems.every(item => item.msku !== row.msku)) {
          this.form.variationAsinItems.push(row);
          this.refreshAddBtn();
        }
      },
      deleteAllItem() {
        this.form.variationAsinItems = [];
        this.refreshAddBtn();
      },
      deleteItem(index) {
        this.form.variationAsinItems.splice(index, 1);
        this.refreshAddBtn();
      },
      refreshAddBtn() {
        if (isMeaningful(this.originTableData)) {
          this.originTableData.forEach(item => {
            const find = (this.form.variationAsinItems || []).some(pickedItem => {
              return meaningfulEq(item.variationAsin, pickedItem.variationAsin);
            });
            if (find) {
              this.$set(item, 'addBtnDisabled', true);
            } else {
              this.$set(item, 'addBtnDisabled', false);
            }
          });
        }
      }
    }
  }
</script>

<style scoped>
</style>





